import { capturePorterCallbackFromUrl } from "./infrastructure/porter-callback";

capturePorterCallbackFromUrl();
